import React from "react";

import { FormattedMessage } from "react-intl";

import NavBar from "../../components/NavBar";
import NavBarItem from "../../components/NavBarItem";

import { routes } from "../../constants/routes";


const P24NavBar = ({children}) => {

    return (

        <div className="p24NavBar">
            <NavBar className="w3-bar w3-black w3-small">
                <NavBarItem isVisible={true} url={routes.P24_TRANSACTIONS}>
                    <i className="fas fa-dollar-sign w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.p24TransactionPage.title"
                        defaultMessage="P24 Transactions"
                    /></p>
                </NavBarItem>
                <NavBarItem isVisible={true} url={routes.P24_MERCHANTS}>
                    <i className="fas fa-user-tie w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.p24MerchantPage.title"
                        defaultMessage="P24 Merchants"
                    /></p>
                </NavBarItem>
                <NavBarItem isVisible={true} url={routes.P24_LOGS}>
                    <i className="fas fa-compact-disc w3-xxlarge" />
                    <p><FormattedMessage
                        id="app.p24LogPage.title"
                        defaultMessage="P24 Logs"
                    /></p>
                </NavBarItem>
            </NavBar>
            <div>
                {children}
            </div>
        </div>

    )

}

export default P24NavBar;